import React from 'react';
import {
    Responsive,
    Datagrid,
    SimpleList,
    TextField,
    SelectInput,
} from 'admin-on-rest';
import List from '../admin/List';
import FilterWithSubmit from '../admin/FilterWithSubmit';
import {MONTHS, YEARS} from '../shared/dateTimeLists';
import {viewStyles} from '../shared/styles-view';
import Avatar from 'material-ui/Avatar';
import Icon from 'material-ui/svg-icons/alert/error-outline';

export const fuseMissingIcon = Icon;

// DEPRECATED in favor of MissingScans view

/*
 * View: List
 */

const MissingListFilter = (props) => (
    <FilterWithSubmit {...props} filterButton="Find Missing Products">
        <SelectInput source="filter_missing_year"
                     label="Select a Year" optionValue="id" optionText="name"
                     choices={YEARS}
                     style={{...viewStyles.filterLeft, ...viewStyles.rowField}}
                     alwaysOn
        />
        <SelectInput source="filter_missing_month"
                     label="Select a Month" optionValue="id" optionText="name"
                     choices={MONTHS}
                     style={{...viewStyles.filterLeft, ...viewStyles.rowField}}
                     alwaysOn
        />
    </FilterWithSubmit>
);

// Set title for List Missing Products
const ListTitle = <span><Avatar icon={<Icon/>} style={viewStyles.avatar} className="avatar-title"/>Missing Products</span>;

const ListDescription = () => {
    return (
        <span>
            <p>Occasionally Products will have barcodes that are not recognized by the system, because the Product does
                not yet exist, an Alias for the Product is needed, or the Product is not sold by this store.</p>
            <p>Search by year and month below to view missing items.</p>
        </span>
    );
};

export const fuseMissingProductList = (props) => (
    <List {...props} title={ListTitle} desc={<ListDescription/>} filters={<MissingListFilter/>}
          perPage={100} sort={{field: 'id', order: 'ASC'}}>
        <Responsive
            small={
                <SimpleList
                    primaryText={record => record.id}
                    secondaryText={record => record.yearmonth}
                    tertiaryText={record => record.location}
                />
            }
            medium={
                <Datagrid bodyOptions={{stripedRows: false, showRowHover: true}}>
                    <TextField source="id" label="ID / Barcode"/>
                    <TextField source="location" label="Location"/>
                    <TextField source="yearmonth" label="Year/Month"/>
                </Datagrid>
            }
        />
    </List>
);



// WEBPACK FOOTER //
// ./src/Fuse/Inventory/missing.js